module.exports = __webpack_public_path__ + "static/media/moraine-16.b05efe86.jpg";